export enum OnboardCMPServiciesType {
  SAAS = 'SaaS',
  AZURE = 'Azure',
}
